import { mapToKnownNablaRegionOrNull } from "auth/utils";
import { Background } from "components/Background/Backgound";
import { Button } from "components/Button/Button";
import { useUser } from "contexts/User/UserContext";
import {
  RegionForEmail,
  StartAccountPasswordReset,
} from "generated/unauth-account";
import { useLazyQuery } from "graphql-client/useLazyQuery";
import { useMutation } from "graphql-client/useMutation";
import { useTranslation } from "i18n";
import { notifier } from "utils/notifier";

export const SecuritySettings = () => {
  const t = useTranslation();
  const { email } = useUser();
  const [fetchRegionForEmail] = useLazyQuery(RegionForEmail, {
    context: { region: "CLOSEST_REGION" },
  });
  const [startAccountPasswordReset] = useMutation(StartAccountPasswordReset, {
    onSuccess: () => notifier.success(t("preferences.security.email_success")),
  });

  return (
    <Background className="flex-col flex-fill overflow-auto p-16 lg:p-44 space-y-24">
      <div className="flex-col">
        <h1 className="text-primary-dark text-24 font-bold">
          {t("preferences.security.security_settings")}
        </h1>
      </div>
      {email && (
        // Changing the password doesn't make sense if the user doesn't have an email, so this is fine.
        <div className="flex-col w-full items-start gap-24 p-32 bg-white border rounded shadow-sm-outlined">
          <div className="space-y-12">
            <h3 className="font-bold text-18 text-primary-dark">
              {t("preferences.security.password")}
            </h3>
            <p>{t("preferences.security.password_subtitle")}</p>
            <Button
              label={t("preferences.security.button_label")}
              onClick={async () => {
                try {
                  const regionForEmailResult = await fetchRegionForEmail({
                    variables: { email },
                  });
                  if (!regionForEmailResult.data?.regionForEmail?.region) {
                    throw new Error("No nabla region found.");
                  }
                  const requestRegion = mapToKnownNablaRegionOrNull(
                    regionForEmailResult.data.regionForEmail.region,
                  );
                  if (!requestRegion) {
                    throw new Error("Nabla region not supported.");
                  }

                  await startAccountPasswordReset(
                    { email },
                    { requestContext: { region: requestRegion } },
                  );
                } catch (e) {
                  console.error(e);
                  notifier.error({
                    user: t("choose_credentials.reset_password_failed"),
                  });
                }
              }}
            />
          </div>
        </div>
      )}
    </Background>
  );
};
